import React, { Children, cloneElement, ReactChild, ReactElement } from 'react';
import classNames from 'classnames';

const SplitButton: React.SFC<PropDef> = ({ children }) => (
  <div className="split-button">
    {Children.map(children, (child: ReactElement<any>) => (
      cloneElement(child, {
        className: classNames(
          child.props.className,
          'split-button__child',
        ),
      })
    ))}
  </div>
);

interface PropDef {
  children: ReactChild[];
}

export default SplitButton;

